import React, { useEffect, useState, useRef } from "react";
import { ProductCard } from "../../components/client/ProductCard";
import { ImageCarousel } from "../../components/client/ImageCarousel";
import { Link, useNavigate, useParams } from "react-router-dom";
import axios from "axios";
// import { moneyFormat } from "../../util/format";
import { toast } from "react-toastify";
import FlashDealPriceBar from "../../components/client/FlashDealPriceBar";

function capitalizeFirstLetter(str) {
  if (!str) return "";
  return str.charAt(0).toLocaleUpperCase("vi") + str.slice(1);
}

// ExpandableContent component giữ nguyên
const ExpandableContent = ({ html, maxHeight = 200, active }) => {
  const [expanded, setExpanded] = useState(false);
  const [overflows, setOverflows] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    if (active && ref.current) {
      setTimeout(() => {
        if (ref.current) {
          setOverflows(ref.current.scrollHeight > maxHeight);
        }
      }, 0);
    }
  }, [html, maxHeight, active]);

  useEffect(() => {
    if (!active) setExpanded(false);
  }, [active]);

  return (
    <div className="relative">
      <div
        ref={ref}
        style={{
          maxHeight: expanded ? "none" : `${maxHeight}px`,
          overflow: expanded ? "visible" : "hidden",
          transition: "max-height 0.3s",
        }}
        dangerouslySetInnerHTML={{ __html: html }}
      />
      {!expanded && overflows && (
        <div
          className="absolute left-0 bottom-0 w-full flex justify-center items-end z-10"
          style={{
            height: "56px",
            background:
              "linear-gradient(180deg, rgba(255,255,255,0.6) 0%, rgba(255,255,255,0.95) 100%)",
            cursor: "pointer",
            pointerEvents: "auto",
          }}
          onClick={() => setExpanded((prev) => !prev)}
        >
          <span
            className="flex items-center gap-2 px-2 py-1 font-semibold"
            style={{
              color: "#1677ff",
              background: "none",
              boxShadow: "none",
              borderRadius: 0,
              fontSize: "1rem",
              cursor: "pointer",
              transition: "color 0.15s",
            }}
          >
            Xem thêm
            <i
              className="fa fa-chevron-down"
              style={{ fontSize: "17px", color: "#1677ff" }}
            ></i>
          </span>
        </div>
      )}
      {expanded && overflows && (
        <div
          className="w-full flex justify-center items-end z-10 mt-4"
          style={{ cursor: "pointer", pointerEvents: "auto" }}
          onClick={() => setExpanded((prev) => !prev)}
        >
          <span
            className="flex items-center gap-2 px-2 py-1 font-semibold"
            style={{
              color: "#1677ff",
              background: "none",
              boxShadow: "none",
              borderRadius: 0,
              fontSize: "1rem",
              cursor: "pointer",
              transition: "color 0.15s",
            }}
          >
            Thu gọn
            <i
              className="fa fa-chevron-up"
              style={{ fontSize: "17px", color: "#1677ff" }}
            ></i>
          </span>
        </div>
      )}
    </div>
  );
};

export const ProductDetail = () => {
  const [activeTab, setActiveTab] = useState(0);
  const navigate = useNavigate();
  const { id } = useParams();
  const [data, setData] = useState(null);
  const [products, setProducts] = useState([]);
  const [reviews, setReviews] = useState([]);
  const [images, setImages] = useState([]);
  const [quantity, setQuantity] = useState(1);
  const userId = localStorage.getItem("userId");
  const [rating, setRating] = useState(0);
  const [reviewText, setReviewText] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [reviewError, setReviewError] = useState("");
  const [optionsState, setOptionsState] = useState([]);
  const [selectedMap, setSelectedMap] = useState({}); // Thêm state mới
  // Thêm state để track việc đã handle hay chưa
  const [hasHandleSelection, setHasHandleSelection] = useState(false);

  const sortOption = () => {
    setOptionsState((prev) => {
      return prev.map((option) => ({
        ...option,
        values: option.values.sort((a, b) =>
          a.value.localeCompare(b.value, "vi"),
        ),
      }));
    });
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    getData();
  }, [id]);

  useEffect(() => {
    findRelatedOptions();

    if (!hasHandleSelection) return;
    // Tìm product match và redirect nếu có
    const matchingProducts = findMatchingProduct();
    if (matchingProducts?.length > 0) {
      const matchedProduct = matchingProducts[0]; // Lấy product đầu tiên match
      if (matchedProduct.slug !== id) {
        // Chỉ redirect nếu khác sản phẩm hiện tại
        setHasHandleSelection(false);
        navigate(`/san-pham/${matchedProduct.slug}`);
      }
    }
  }, [selectedMap]);

  // Khởi tạo optionsState với mỗi value là object có active/disabled riêng
  useEffect(() => {
    if (data?.selectableOptions) {
      // Map {optionId: value} từ optionMappings
      const initialSelectedMap = {};
      if (Array.isArray(data.optionMappings)) {
        data.optionMappings.forEach((item) => {
          if (item.optionId && item.value != "") {
            initialSelectedMap[item.optionId] = item.value;
          }
        });
      }
      setSelectedMap(initialSelectedMap);

      // Tìm các product có thể kết hợp với initialSelectedMap
      const matchingProducts = data.relatedProducts.filter((product) => {
        return Object.entries(initialSelectedMap).every(
          ([optionId, selectedValue]) => {
            return product.optionMappings.some(
              (mapping) =>
                mapping.optionId === parseInt(optionId) &&
                mapping.value === selectedValue,
            );
          },
        );
      });

      // Thu thập các value có thể chọn
      const selectableValues = new Map();
      matchingProducts.forEach((product) => {
        product.optionMappings.forEach((mapping) => {
          if (!selectableValues.has(mapping.optionId)) {
            selectableValues.set(mapping.optionId, new Set());
          }
          selectableValues.get(mapping.optionId).add(mapping.value);
        });
      });

      setOptionsState(
        data.selectableOptions.map((opt) => {
          // Lọc value trùng (không phân biệt dấu/hoa thường)
          const seenValue = new Set();
          const allowedValues = selectableValues.get(opt.id) || new Set();

          const valuesArr = (opt.values || [])
            .filter(Boolean)
            .filter((val) => {
              if (!val) return false;
              if (seenValue.has(val)) return false;
              seenValue.add(val);
              return true;
            })
            .map((val) => {
              const isActive = initialSelectedMap[opt.id] == val;
              // Kiểm tra xem option này có value nào active không
              const hasActiveValue = !!initialSelectedMap[opt.id];

              return {
                value: val,
                active: isActive,
                // Nếu option có value active -> disabled = false cho tất cả
                // Nếu không -> chỉ những value có trong allowedValues mới disabled = false
                disabled: hasActiveValue ? false : !allowedValues.has(val),
              };
            });

          return {
            id: opt.id,
            name: opt.name,
            values: valuesArr,
          };
        }),
      );

      sortOption();
    }
  }, [data?.selectableOptions, data?.optionMappings]);

  // Lấy data product, lọc trùng options
  const getData = () => {
    axios
      .get("/product/public/show-by-slug/" + id)
      .then((res) => {
        let productDetail = res.data?.data;
        setImages(productDetail?.imagesUrl);

        // Thêm product hiện tại vào relatedProducts trước khi chuẩn hóa
        const currentProduct = {
          id: productDetail.id,
          slug: productDetail.slug,
          optionMappings: productDetail.optionMappings,
        };
        productDetail.relatedProducts = [
          ...productDetail.relatedProducts,
          currentProduct,
        ];

        // Sau đó mới chuẩn hóa tất cả
        productDetail.optionMappings = productDetail.optionMappings.map(
          (e) => ({
            ...e,
            value: capitalizeFirstLetter(
              e.value.normalize().trim().toLowerCase(),
            ),
          }),
        );

        productDetail.selectableOptions = productDetail.selectableOptions.map(
          (e) => ({
            ...e,
            values: e.values.map((v) =>
              capitalizeFirstLetter(v.normalize().trim().toLowerCase()),
            ),
          }),
        );

        productDetail.relatedProducts = productDetail.relatedProducts.map(
          (e) => ({
            ...e,
            optionMappings: e.optionMappings.map((omp) => ({
              ...omp,
              value: capitalizeFirstLetter(
                omp.value.normalize().trim().toLowerCase(),
              ),
            })),
          }),
        );

        // Lọc trùng selectableOptions theo id
        if (Array.isArray(productDetail.selectableOptions)) {
          const seenOption = new Set();
          productDetail.selectableOptions =
            productDetail.selectableOptions.filter((opt) => {
              if (seenOption.has(opt.id)) return false;
              seenOption.add(opt.id);
              return true;
            });
        }

        setData(productDetail);
        getReviewList(productDetail);
        getProductList(productDetail?.category?.id, productDetail?.id);
      })
      .catch((err) => console.log(err));
  };

  const getReviewList = (productDetail) => {
    axios
      .get("/review/product/public/shows", {
        params: {
          page: 1,
          limit: 10,
          ableId: productDetail?.id,
        },
      })
      .then((res) => {
        setReviews(res.data.data?.reviews || []);
      })
      .catch((err) => console.log(err));
  };

  const getProductList = (id, detailId) => {
    axios
      .get("/product/public/shows?categoryId=" + id)
      .then((res) => {
        const productData = res.data.data?.products?.filter(
          (x) => x.id !== detailId,
        );
        setProducts(productData);
      })
      .catch((err) => console.log(err));
  };

  // Khi chọn value, cập nhật active/disabled từng value của option
  const handleSelectOption = (optionId, value) => {
    setHasHandleSelection(true);

    setSelectedMap((prev) => {
      if (prev[optionId] === value) {
        const newMap = { ...prev };
        delete newMap[optionId];
        return newMap;
      }

      const newMap = {
        ...prev,
        [optionId]: value,
      };

      if (Object.keys(newMap).length === data.selectableOptions.length) {
        const matchingProducts = data.relatedProducts.filter((product) => {
          return Object.entries(newMap).every(([optId, selectedValue]) => {
            return product.optionMappings.some(
              (mapping) =>
                mapping.optionId === parseInt(optId) &&
                mapping.value === selectedValue,
            );
          });
        });

        if (matchingProducts.length === 0) {
          return { [optionId]: value };
        }
      }

      return newMap;
    });
  };

  // Thêm useEffect mới để xử lý optionsState khi selectedMap thay đổi
  useEffect(() => {
    if (!data?.selectableOptions) return;

    // Nếu không có option nào được chọn -> enable tất cả values
    if (Object.keys(selectedMap).length === 0) {
      setOptionsState((prev) =>
        prev.map((opt) => ({
          ...opt,
          values: opt.values.map((v) => ({
            ...v,
            active: false,
            disabled: false,
          })),
        })),
      );
      return;
    }

    // Logic xử lý khi có options được chọn
    const matchingProducts = data.relatedProducts.filter((product) => {
      return Object.entries(selectedMap).every(([optionId, selectedValue]) => {
        return product.optionMappings.some(
          (mapping) =>
            mapping.optionId === parseInt(optionId) &&
            mapping.value === selectedValue,
        );
      });
    });

    // ...rest of the existing code for collecting selectableValues
    const selectableValues = new Map();
    matchingProducts.forEach((product) => {
      product.optionMappings.forEach((mapping) => {
        if (!selectableValues.has(mapping.optionId)) {
          selectableValues.set(mapping.optionId, new Set());
        }
        selectableValues.get(mapping.optionId).add(mapping.value);
      });
    });

    setOptionsState((prev) =>
      prev.map((opt) => {
        const allowedValues = selectableValues.get(opt.id) || new Set();
        const hasActiveValue = !!selectedMap[opt.id];

        return {
          ...opt,
          values: opt.values.map((v) => ({
            ...v,
            active:
              opt.id in selectedMap ? selectedMap[opt.id] === v.value : false,
            disabled: hasActiveValue ? false : !allowedValues.has(v.value),
          })),
        };
      }),
    );
  }, [selectedMap, data?.selectableOptions, data?.relatedProducts]);

  // Cart logic
  const handleAddToCart = () => {
    const productId = data?.id;
    const name = data?.name;
    const price = data?.salePrice;
    const originalPrice = data?.originalPrice;
    const image = data?.imagesUrl[0];
    const slug = data?.slug || "";
    const selectedOptions = data?.optionMappings;

    // Lấy lựa chọn option của user
    // const selectedOptions = optionsState.map((opt) => ({
    //   name: opt.name,
    //   value: opt.values.find((v) => v.active)?.value || null,
    // }));

    const existingCart = JSON.parse(localStorage.getItem("cart")) || [];
    const existingItemIndex = existingCart.findIndex(
      (item) => item.productId === productId,
    );

    if (existingItemIndex !== -1) {
      existingCart[existingItemIndex].quantity += quantity;
    } else {
      existingCart.push({
        productId,
        quantity,
        name,
        originalPrice,
        price,
        image,
        slug,
        options: selectedOptions,
      });
    }

    localStorage.setItem("cart", JSON.stringify(existingCart));
    window.dispatchEvent(new Event("cartUpdated"));
    toast.success("Thêm vào giỏ hàng thành công");
  };

  const handleBuyNow = () => {
    handleAddToCart();
    navigate("/cart");
  };

  const handleDecrease = () => {
    setQuantity((prev) => (prev > 1 ? prev - 1 : 1));
  };

  const handleIncrease = () => {
    setQuantity((prev) => prev + 1);
  };

  const handleReviewSubmit = (e) => {
    e.preventDefault();
    setReviewError("");

    if (!userId) {
      setReviewError("Vui lòng đăng nhập để đánh giá sản phẩm");
      return;
    }
    if (rating === 0) {
      setReviewError("Vui lòng chọn số sao đánh giá");
      return;
    }
    if (!reviewText.trim()) {
      setReviewError("Vui lòng nhập nội dung đánh giá");
      return;
    }

    const reviewData = {
      ableId: data?.id,
      rating: rating,
      reviewText: reviewText.trim(),
    };

    setSubmitting(true);

    axios
      .post("/review/product/create", reviewData)
      .then(() => {
        toast.success("Đánh giá sản phẩm thành công");
        setRating(0);
        setReviewText("");
        getReviewList(data);
        setActiveTab(0);
      })
      .catch((err) => {
        setReviewError(
          err.response?.data?.messages?.ableId ||
            err.response?.data?.messages?.message ||
            err.response?.data?.messages?.rating ||
            err.response?.data?.messages?.reviewText ||
            "Không thể gửi đánh giá. Vui lòng thử lại sau.",
        );
      })
      .finally(() => setSubmitting(false));
  };

  const handleRatingClick = (value) => {
    setRating(value);
    setReviewError("");
  };

  const calculateStarPercentage = (starPosition, rating) => {
    if (starPosition <= Math.floor(rating)) return 100;
    else if (starPosition > Math.ceil(rating)) return 0;
    else return Math.round((rating - Math.floor(rating)) * 100);
  };

  const findMatchingProduct = () => {
    // Tìm product có optionMappings CHÍNH XÁC với selectedMap
    return data?.relatedProducts?.filter((product) => {
      // Product phải có ĐÚNG số lượng option mappings với selectedMap
      if (product.optionMappings.length !== Object.keys(selectedMap).length) {
        return false;
      }

      // Kiểm tra từng option mapping của product
      return product.optionMappings.every(
        (mapping) =>
          // Option này có được chọn không
          mapping.optionId in selectedMap &&
          // Và giá trị có đúng không
          selectedMap[mapping.optionId] === mapping.value,
      );
    });
  };

  // Thêm hàm mới để tìm các option values có thể kết hợp
  const findRelatedOptions = () => {
    // Nếu chưa handle thì không làm gì cả
    if (!hasHandleSelection) return;

    // Nếu chưa chọn option nào hoặc không có related products
    if (!Object.keys(selectedMap).length || !data?.relatedProducts?.length) {
      return;
    }

    // Tìm các related products có chứa tất cả options đã chọn
    const matchingProducts = data.relatedProducts.filter((product) => {
      return Object.entries(selectedMap).every(([optionId, selectedValue]) => {
        return product.optionMappings.some(
          (mapping) =>
            mapping.optionId === parseInt(optionId) &&
            mapping.value === selectedValue,
        );
      });
    });

    // Tạo map để lưu các value có thể chọn cho mỗi optionId
    const selectableValues = new Map();

    // Thu thập tất cả các value từ optionMappings của matching products
    matchingProducts.forEach((product) => {
      product.optionMappings.forEach((mapping) => {
        if (!selectableValues.has(mapping.optionId)) {
          selectableValues.set(mapping.optionId, new Set());
        }
        selectableValues.get(mapping.optionId).add(mapping.value);
      });
    });

    // Cập nhật optionsState
    setOptionsState((prev) =>
      prev.map((opt) => {
        const allowedValues = selectableValues.get(opt.id) || new Set();

        // Kiểm tra xem option này có value nào active không
        const hasActiveValue = opt.values.some((v) => v.active);

        return {
          ...opt,
          values: opt.values.map((v) => ({
            ...v,
            // Nếu option có value active -> tất cả value disabled = false
            // Nếu không -> chỉ những value có trong allowedValues mới disabled = false
            disabled: hasActiveValue ? false : !allowedValues.has(v.value),
          })),
        };
      }),
    );
  };

  return (
    <>
      <div className="container-fluid">
        <div className="row px-xl-5">
          <div className="col-12">
            <nav className="breadcrumb bg-light mb-30">
              <a className="breadcrumb-item text-dark" href="#">
                Trang chủ
              </a>
              <Link className="breadcrumb-item text-dark" to={`/san-pham`}>
                Sản phẩm
              </Link>
              <span className="breadcrumb-item active">{data?.name}</span>
            </nav>
          </div>
        </div>
      </div>

      <div className="container-fluid pb-5">
        <div className="row px-xl-5">
          {/* ImageCarousel */}
          <div className="col-12 col-md-6 d-flex align-items-start justify-content-center mb-4 mb-md-0">
            <ImageCarousel images={images} />
          </div>
          {/* Product info */}
          <div className="col-12 mb-4 col-md-6 d-flex flex-column justify-content-between">
            <div className="h-100 bg-light p-30 max-sm:px-4 pb-16">
              <h1 className="text-2xl font-bold">{data?.name}</h1>

              <div className="d-flex mb-3">
                <div className="text-warning mr-2" title={data?.averageRating}>
                  {data?.totalReviews > 0 ? (
                    <>
                      {[...Array(5)].map((_, index) => {
                        const starPosition = index + 1;
                        const percentage = calculateStarPercentage(
                          starPosition,
                          data.averageRating,
                        );
                        return (
                          <span
                            key={index}
                            style={{
                              position: "relative",
                              display: "inline-block",
                            }}
                          >
                            <small
                              className="far fa-star"
                              style={{ color: "#e0e0e0" }}
                            ></small>
                            <span
                              style={{
                                position: "absolute",
                                top: 0,
                                left: 0,
                                width: `${percentage}%`,
                                overflow: "hidden",
                                color: "#ffc107",
                              }}
                            >
                              <small className="fas fa-star"></small>
                            </span>
                          </span>
                        );
                      })}
                    </>
                  ) : (
                    <>
                      {[...Array(5)].map((_, index) => (
                        <small key={index} className="far fa-star"></small>
                      ))}
                    </>
                  )}
                </div>
                <small className="pt-1">
                  ({data?.totalReviews || 0} đánh giá)
                </small>
              </div>

              {/* <div className="mb-4">
                <h3 className="mb-4 text-2xl font-bold text-red-500">
                  {moneyFormat(data?.salePrice)}
                  <span className="text-muted text-sm line-through ml-2">
                    {moneyFormat(data?.originalPrice)}
                  </span>
                </h3>
              </div> */}

              {data?.brand && (
                <div className="mb-3">
                  <span className="text-primary">Thương hiệu: </span>
                  <span className="text-dark">{data?.brand?.name}</span>
                </div>
              )}

              <FlashDealPriceBar
                price={data?.salePrice}
                originalPrice={data?.originalPrice}
              />

              <p className="mb-4">{data?.description}</p>

              {/* --- Render từng option thành từng dòng --- */}
              {optionsState.length > 0 && (
                <div className="mb-4">
                  {optionsState.map((opt) => (
                    <div key={opt.id} className="mb-3">
                      <span className="font-semibold">{opt.name}: </span>
                      <div className="flex gap-2 mt-1 flex-wrap">
                        {opt.values.map((v, idx) => (
                          <button
                            key={idx}
                            className={`
                              px-2 py-1 rounded-lg transition-all duration-200 outline-none focus:outline-none active:outline-non
                              ${
                                v.active
                                  ? "bg-blue-500 text-white border-2 border-blue-600"
                                  : "bg-white text-gray-700 border border-gray-200 hover:bg-blue-50"
                              }
                              ${
                                v.disabled
                                  ? "opacity-35 cursor-not-allowed filter grayscale"
                                  : "hover:border-blue-300"
                              }
                            `}
                            disabled={v.disabled}
                            onClick={() => handleSelectOption(opt.id, v.value)}
                            style={{
                              transform: v.active ? "translateY(-1px)" : "none",
                            }}
                          >
                            {v.value}
                          </button>
                        ))}
                      </div>
                    </div>
                  ))}
                </div>
              )}

              <div className="align-items-center mb-4 pt-2">
                <div
                  className="input-group quantity mr-3"
                  style={{ width: "130px" }}
                >
                  <div className="input-group-btn">
                    <button
                      className="btn btn-primary btn-minus"
                      onClick={handleDecrease}
                    >
                      <i className="fa fa-minus"></i>
                    </button>
                  </div>
                  <input
                    type="text"
                    className="form-control bg-secondary border-0 text-center"
                    value={quantity}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (/^\d*$/.test(value)) {
                        setQuantity(value === "" ? "" : parseInt(value, 10));
                      }
                    }}
                  />
                  <div className="input-group-btn">
                    <button
                      className="btn btn-primary btn-plus"
                      onClick={handleIncrease}
                    >
                      <i className="fa fa-plus"></i>
                    </button>
                  </div>
                </div>
                <div className="max-md:py-2 md:pb-0 md:mt-4 max-md:bg-white px-4 max-md:fixed max-md:bottom-0 left-0 w-full z-[1024] flex justify-center items-center gap-4 md:absolute md:z-0">
                  <button
                    className="btn btn-primary p-2 w-40 md:w-48 max-md:mr-3 text-sm rounded md:text-base"
                    onClick={handleAddToCart}
                  >
                    <i className="fa fa-shopping-cart mr-1"></i> Thêm giỏ hàng
                  </button>
                  <button
                    className="btn btn-danger p-2 w-40 md:w-48 text-sm rounded md:text-base"
                    onClick={handleBuyNow}
                  >
                    <i className="fa fa-shopping-cart mr-1"></i> Mua ngay
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Tabs: hiệu ứng xem thêm cho cả 2 tab */}
        <div className="row px-xl-5">
          <div className="col">
            <div className="bg-light p-30 pb-4">
              <div className="nav nav-tabs mb-4">
                {["Mô tả sản phẩm", "Thông tin sản phẩm"].map((tab, index) => (
                  <a
                    key={index}
                    data-toggle="tab"
                    className={`nav-item nav-link text-dark ${activeTab === index ? "active" : ""}`}
                    onClick={() => setActiveTab(index)}
                    style={{ cursor: "pointer" }}
                  >
                    {tab}
                  </a>
                ))}
              </div>
              <div className="tab-content">
                <div
                  className={`tab-pane fade ${activeTab === 0 ? "show active" : ""}`}
                >
                  <h4 className="mb-3">Mô tả sản phẩm</h4>
                  <ExpandableContent
                    html={data?.content || ""}
                    maxHeight={200}
                    active={activeTab === 0}
                  />
                </div>
                <div
                  className={`tab-pane fade ${activeTab === 1 ? "show active" : ""}`}
                >
                  <h4 className="mb-3">Thông tin sản phẩm</h4>
                  <ExpandableContent
                    html={
                      data?.attributeValues?.length
                        ? `<ul>${data.attributeValues.map((item) => `<li><strong>${item.attribute.name}:</strong> ${item.value}</li>`).join("")}</ul>`
                        : "<p>Không có thông tin sản phẩm</p>"
                    }
                    maxHeight={200}
                    active={activeTab === 1}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Đánh giá sản phẩm */}
        <div className="row px-xl-5 mt-5">
          <div className="col">
            <div className="bg-light p-30">
              <div className="row">
                <div className="col-md-6 mb-4">
                  <div className="bg-light p-4 rounded shadow-sm">
                    <h5 className="mb-4 text-primary">
                      <i className="fas fa-comments mr-2"></i>
                      {reviews.length} đánh giá cho &quot;
                      <strong>{data?.name}</strong>&quot;
                    </h5>
                    {reviews.length > 0 ? (
                      <div
                        className="review-list"
                        style={{ maxHeight: "500px", overflowY: "auto" }}
                      >
                        {reviews.map((item, idx) => (
                          <div
                            className="media mb-4 p-3 bg-white rounded"
                            key={idx}
                            style={{ boxShadow: "0 1px 3px rgba(0,0,0,0.1)" }}
                          >
                            {item?.user?.avatar_url ? (
                              <img
                                src={
                                  item?.user?.avatar_url || "/images/avatar.png"
                                }
                                alt="User"
                                className="img-fluid mr-3 mt-1 rounded-circle bg-secondary"
                                style={{
                                  width: "45px",
                                  height: "45px",
                                  objectFit: "cover",
                                }}
                              />
                            ) : (
                              <i className="fa-solid fa-user text-muted rounded-circle bg-secondary w-10 h-10 flex items-center justify-center" />
                            )}
                            <div className="media-body ms-2">
                              <h6 className="d-flex justify-content-between align-items-center">
                                <span>{item?.user?.full_name}</span>
                                <small className="text-muted">
                                  <i className="far fa-calendar-alt mr-1"></i>
                                  {new Date(item?.createdAt).toLocaleDateString(
                                    "vi-VN",
                                  )}
                                </small>
                              </h6>
                              <div className="text-warning mb-2">
                                {[...Array(5)].map((_, index) => (
                                  <i
                                    key={index}
                                    className={
                                      index < item.rating
                                        ? "fas fa-star"
                                        : "far fa-star"
                                    }
                                  ></i>
                                ))}
                              </div>
                              <p className="mb-0">{item?.reviewText}</p>
                            </div>
                          </div>
                        ))}
                      </div>
                    ) : (
                      <div className="text-center py-5">
                        <i className="far fa-comment-alt fa-3x text-muted mb-3"></i>
                        <p>Chưa có đánh giá nào cho sản phẩm này</p>
                      </div>
                    )}
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="bg-light p-4 rounded shadow-sm">
                    <h5 className="mb-4">
                      <i className="fas fa-star mr-2 text-warning"></i>
                      Để lại đánh giá
                    </h5>
                    {!userId ? (
                      <div
                        className="alert alert-warning d-flex align-items-center"
                        role="alert"
                      >
                        <i className="fas fa-exclamation-circle mr-2"></i>
                        <div>
                          Vui lòng{" "}
                          <Link to="/login" className="alert-link">
                            đăng nhập
                          </Link>{" "}
                          để đánh giá sản phẩm
                        </div>
                      </div>
                    ) : (
                      <form onSubmit={handleReviewSubmit}>
                        <div className="form-group">
                          <label htmlFor="rating" className="font-weight-bold">
                            Đánh giá của bạn
                          </label>
                          <div className="rating-container d-flex align-items-center my-2">
                            <div className="text-warning d-flex">
                              {[...Array(5)].map((_, index) => (
                                <i
                                  key={index}
                                  className={
                                    index < rating
                                      ? "fas fa-star fa-lg"
                                      : "far fa-star fa-lg"
                                  }
                                  style={{
                                    cursor: "pointer",
                                    marginRight: "8px",
                                    transition: "all 0.2s",
                                  }}
                                  onClick={() => handleRatingClick(index + 1)}
                                ></i>
                              ))}
                            </div>
                            {rating > 0 && (
                              <span className="ml-3 badge badge-warning h-7 w-7 flex items-center justify-center">
                                {rating}/5
                              </span>
                            )}
                          </div>
                        </div>
                        <div className="form-group">
                          <label htmlFor="message" className="font-weight-bold">
                            Nội dung đánh giá
                          </label>
                          <textarea
                            id="message"
                            cols="30"
                            rows="4"
                            className="form-control"
                            value={reviewText}
                            placeholder="Chia sẻ trải nghiệm của bạn về sản phẩm..."
                            onChange={(e) => {
                              setReviewText(e.target.value);
                              setReviewError("");
                            }}
                            disabled={submitting}
                          ></textarea>
                        </div>
                        {reviewError && (
                          <div
                            className="alert alert-danger d-flex align-items-center"
                            role="alert"
                          >
                            <i className="fas fa-exclamation-circle mr-2"></i>
                            {reviewError}
                          </div>
                        )}
                        <div className="form-group mb-0 text-right">
                          <button
                            type="submit"
                            className="btn btn-success px-4"
                            disabled={submitting}
                          >
                            {submitting ? (
                              <>
                                <span
                                  className="spinner-border spinner-border-sm mr-2"
                                  role="status"
                                  aria-hidden="true"
                                ></span>
                                Đang gửi...
                              </>
                            ) : (
                              <>
                                <i className="fas fa-paper-plane mr-2"></i>
                                Gửi đánh giá
                              </>
                            )}
                          </button>
                        </div>
                      </form>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="container-fluid py-5">
        <h4 className="section-title position-relative text-uppercase mx-xl-5 mb-4">
          <span className="bg-secondary pr-3">Có thể bạn sẽ thích</span>
        </h4>
        <div className="px-xl-5">
          <div className="w-full grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
            {products?.map((product) => (
              <div key={product.id} className="w-full mt-4">
                <ProductCard product={product} maxSize={true} />
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};
